import { useEffect, useState } from "react"
import { IListaProgramacionPersona, IProgramacionPorPersona } from "../../../interfaces/IProgramacion"
import PersonaService from "../../../services/PersonaService"
import { codigosRespuesta, IResponseApiFluent } from "../../../interfaces/base/IResponse"
import { IOpenPanel } from "../../../interfaces/base/IPanel"

const UseCambioEmpresa = (programacionPersonaId: string[], openPanel: IOpenPanel) => {
    const [data, setData] = useState<IProgramacionPorPersona[]>([])
    const [command, setCommand] = useState<IListaProgramacionPersona>()
    const [message, setMessage] = useState<string>("")
    const [loading, setLoading] = useState<boolean>(false)
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [disableForm, setDisableForm] = useState<boolean>(true);


    const ActualizarProgramacionTransporteMasivo = () => {
        if (command != undefined) {
            setLoading(true)
            PersonaService.putProgramacionPersonaTransporteMasivo(command)
                .then((res) => {
                    if (res.status == 200) {
                        setStatus(200)
                        setMessage(res.data.mensaje)
                        setTimeout(() => {
                            openPanel.reload?.();
                            cerrarPanel()
                        }, 3000)
                    } else {
                        setStatus(500)
                    }
                    setLoading(false)
                })
                .catch(e => {
                    if (
                        e.response?.data &&
                        'type' in e.response.data &&
                        'title' in e.response.data &&
                        'status' in e.response.data &&
                        'instance' in e.response.data &&
                        'errors' in e.response.data
                    ) {
                        const errorResponse = e.response.data as IResponseApiFluent;
                        const mensajeError = errorResponse.errors.join('\n');
                        setMessage(mensajeError);
                    } else {
                        setMessage("Error Inesperado");
                    }
                    setStatus(500);
                    setLoading(false);
                })
        }
    }

    const cerrarPanel = () => {
        setMessage("")
        setCommand(undefined)
        setLoading(false)
        setStatus(0)
        openPanel.onDismiss()
    };

    const required: (keyof IProgramacionPorPersona)[] = [
        "programacionPersonaId",
        "transporteId"
    ];

    useEffect(() => {
        const allFieldsFilled = data?.every((item) => 
            required.every((field) => 
                item[field] !== null && item[field] !== undefined && item[field] !== ""
            )
        ) ?? false;
    
        setDisableForm(!allFieldsFilled);
    }, [data])

    useEffect(() => {
        if (openPanel.isOpen) {
            if (programacionPersonaId.length > 0) {
                const newData = programacionPersonaId.map((id) => ({
                    programacionPersonaId: id,
                    transporteId: null
                }));
                setData(newData);
            }
        }
    }, [openPanel.isOpen])

    useEffect(() => {
        if (data.length > 0) {
            setCommand({ programacionPorPersona: data })
        }
    }, [data])

    return { ActualizarProgramacionTransporteMasivo, message, setData, command, loading, cerrarPanel, status, disableForm }
}

export { UseCambioEmpresa }

